<template>
    <el-dialog :title="title" :visible.sync="visible" @close="close">
        <div>
            <receipt-cfg-form ref="receiptCfgForm" @save-success="handleSaveSuccess" @save-fail="handleSaveFail" />
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="cancel" size="small">取 消</el-button>
            <el-button @click="confirm" size="small" type="primary">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import ReceiptCfgForm from "@/views/billing/receiptcfg/receipt-cfg-form";
    import {handleError} from "@/util/error-util";

    export default {
        name: "receipt-cfg-form-dialog",
        components: {
            ReceiptCfgForm
        },
        props: {
            title: {
                default: '新增收款账号'
            }
        },
        data() {
            return {
                visible: false,
            };
        },
        computed: {
        },
        watch: {

        },
        methods: {
            open() {
                this.visible = true;
                let receiptCfgForm = this.$refs.receiptCfgForm;
                if (receiptCfgForm != null) {
                    receiptCfgForm.toAdd();
                }
            },
            close() {
                this.visible = false;
            },
            cancel() {
                this.visible = false;
            },
            async confirm() {
                let receiptCfgForm = this.$refs.receiptCfgForm;
                await receiptCfgForm.saveAdd();
                this.visible = false;
            },
            handleSaveSuccess(data) {
                this.$emit('save-success', data);
            },
            handleSaveFail(error) {
                handleError(error);
                this.$emit('save-fail', error);
            },
        },
    }
</script>

<style scoped>

</style>